import { liveCalculationTheme } from './FieldPopoverForm/LiveCalculationPanel/theme';

export const workbookTheme = {
  comment: {
    bg: 'palette.surface.4',
  },
  dailyNet: {
    negative: {
      text: 'palette.error.60',
    },
  },
  liveCalculation: liveCalculationTheme,
};
